/**
 * @author
 * @date 2025.10.28
 * @description 페이지별 iframe URL 설정
 */

interface IframeUrlConfig {
  [path: string]: {
    url: string;
    buttonText: string;
    closeText: string;
    defaultUrl?: string; // 기본으로 자동 열릴 iframe URL
    openInNewTab?: boolean; // 도움말을 새 탭으로 열지 여부
  };
}

// 페이지별 참고 URL 및 버튼 텍스트 설정
export const iframeUrls: IframeUrlConfig = {
  // 주문 관련
  // '/order': {
  //   url: 'https://docs.google.com/document/d/example-order-guide',
  //   buttonText: '주문이 어려우신가요? 클릭하세요!',
  //   closeText: '도움말 닫기',
  // },
  // '/order/list': {
  //   url: 'https://docs.google.com/document/d/example-order-list-guide',
  //   buttonText: '주문 목록 보는법 모르시나요?',
  //   closeText: '도움말 닫기',
  // },
  // '/order/complete': {
  //   url: 'https://docs.google.com/document/d/example-order-complete-guide',
  //   buttonText: '주문 확정 방법이 궁금하세요?',
  //   closeText: '도움말 닫기',
  // },

  // 상품 관련
  '/product': {
    url: 'https://volcano-ixora-b68.notion.site/ebd/29619d1dc0e5803db16cee25b8bc61cb',
    buttonText: '상품 사용 방법이 어려우신가요?',
    closeText: '도움말 닫기',
  },
  '/update/product-image': {
    url: 'https://volcano-ixora-b68.notion.site/ebd/29619d1dc0e5803db16cee25b8bc61cb',
    buttonText: '상품 사용 방법이 어려우신가요?',
    closeText: '도움말 닫기',
  },

  // 오늘의 운세
  '/today-saju': {
    url: 'https://volcano-ixora-b68.notion.site/ebd/27119d1dc0e580278451faeed611aca5',
    buttonText: '오늘의 운세 사용법이 궁금하세요?',
    closeText: '도움말 닫기',
  },

  // 비즈메시지
  '/bizmsg/sender': {
    url: 'https://volcano-ixora-b68.notion.site/fortune-lab-25a19d1dc0e58039bdc0c014f9d0855d',
    defaultUrl: 'https://business.kakao.com/profiles',
    buttonText: '카카오 채널 연동이 어려우신가요? 클릭하세요!',
    closeText: '도움말 닫기',
    openInNewTab: true, // 새창으로 열기 (기존대로 유지)
  },

  // 이메일
  '/email-template': {
    url: 'https://volcano-ixora-b68.notion.site/ebd/24819d1dc0e580d192baeb516de82c13',
    buttonText: '이메일 템플릿 사용 방법이 어려우신가요?',
    closeText: '도움말 닫기',
  },
};

// 현재 경로에 맞는 iframe 설정 가져오기
export const getIframeConfig = (pathname: string) => {
  // 정확히 매칭되는 경로가 있으면 반환
  if (iframeUrls[pathname]) {
    return iframeUrls[pathname];
  }

  // 부분 매칭 시도 (예: /order/123 -> /order)
  const pathSegments = pathname.split('/').filter(Boolean);
  for (let i = pathSegments.length; i > 0; i--) {
    const partialPath = '/' + pathSegments.slice(0, i).join('/');
    if (iframeUrls[partialPath]) {
      return iframeUrls[partialPath];
    }
  }

  // 매칭되는 경로가 없으면 null 반환
  return null;
};

// 호환성을 위한 기존 함수 (URL만 반환)
export const getIframeUrl = (pathname: string): string | null => {
  const config = getIframeConfig(pathname);
  return config ? config.url : null;
};
